import React, { createRef } from "react"
import styled from "styled-components"
import ButtonForm from "./ButtonForm"
import subscribeToMailchimp from "../../utils/subscribeToMailchimp"

const Error = styled.div`
  color: red;
  margin-bottom: 2rem;
  line-height: 1.5rem;
  font-size: 0.9rem;

  a {
    color: red;
    font-family: var(--font-bold);
  }
`

const Form = styled.form`
  input[type="email"] {
    width: 100%;
    padding: 0.7rem 0.5rem 0.5rem 0.5rem;
    margin-bottom: 1rem;
    background-color: var(--${props => props.formFieldBgColor});
    border: 1px solid var(--black);
    font-size: 0.9rem;

    &:focus {
      outline: none;
    }

    &::placeholder {
      font-size: 0.9rem;
      color: var(--black);
    }
  }
`

export default class Mailchimp extends React.Component {
  constructor(props) {
    super(props)
    this.state = { email: "" }
    this.errorMessage = createRef()
  }

  _handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  _handleSubmit = e => {
    e.preventDefault()

    subscribeToMailchimp(this.state.email)
      .then(data => {
        this.errorMessage.current.innerHTML = data.msg
      })
      .catch(err => {
        this.errorMessage.current.innerHTML = err
      })
  }

  render() {
    return (
      <Form
        onSubmit={this._handleSubmit}
        formFieldBgColor={this.props.formFieldBgColor}
      >
        <Error ref={this.errorMessage} className="mailchimp-error"></Error>

        <input
          type="email"
          placeholder="Enter your email"
          onChange={this._handleChange}
          name="email"
          required
        />

        <ButtonForm
          buttonBgColor={this.props.buttonBgColor}
          buttonBgColorHover={this.props.buttonBgColorHover}
          buttonTextColor={this.props.buttonTextColor}
          buttonTextColorHover={this.props.buttonTextColorHover}
          buttonBorderColor={this.props.buttonBorderColor}
          text="Sign up"
        />
      </Form>
    )
  }
}
